<template>
  <div class="">
      <!-- Tax Settings -->

      <br />
      <v-card>

        <v-card-title primary-title>
            <div v-if="chargeTax">
              Sales tax <b>will</b> be added to the price.
            </div>
            <div v-if="!chargeTax">
              Sales tax <b>will not</b> be added to the price.
            </div>
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
            Explain More
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

         </v-btn>

        </v-card-actions>

        <v-slide-y-transition>
          <v-card-text v-show="show" >

            The laws vary by state, but we expect many of our sellers will
            qualify as "occasional sellers" and not require sales
            tax collection. You should check your state laws and a qualified
            tax professional if you are uncertain. If you do decide to collect
            taxes you probably must also register for a state sales tax
            license in most states.
            <br />
            If you collect tax we will use your address as the sales tax nexus.
            Contact us if this is not sufficient.
            <br />

            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Change was successful.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!chargeTax" @click="setCollectTax(true)" flat color="accent">
               Add tax to purchase
            </v-btn>

            <v-btn v-if="chargeTax" @click="setCollectTax(false)" flat color="accent">
               Stop adding tax to purchase
            </v-btn>
          </v-card-actions>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import firebase from 'firebase/app'

export default {
  name: 'TaxSettings',
  components: {
  },
  computed: {
    ...mapState({
      uid: state => state.admin.uid,
      chargeTax: state => state.admin.public_settings.chargeTax || false,
      locked: state => state.admin.public_settings.locked

    })
  },
  data () {
    return {
      show: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null
    }
  },
  methods: {

    setCollectTax: async function (val) {
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      if (this.locked) {
        this.inprogress = false
        this.errMessage = "Account is locked. You cannot update settings."
        return
      }

      try {

        // Call the server function to generate a unique CSRF token to validate later
        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'chargeTax': val
          }, {merge: true})

        this.updateSuccess = true
      } catch (err) {
        this.errMessage = err
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
